import { kinderConnectCaptureSettingsDefaultConfig as defaultConfig, } from '@famly/stat_kinder-connect-capture_lib';
export const useKinderConnectCaptureSettingsConfig = () => {
    return defaultConfig;
};
